const validator = (validations, html) => {
  const results = validations.map(validation => validation(html));

  return results.every(result => result);
};

export default validator;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/helpers/validator.js
 **/